export const ADMIN = 'admin'
export const TEACHER = 'teacher'
export const HIGH_SCHOOL = 'highSchool'
